import './ReceptionDetailForm.scss';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Flex, Form, FormProps, Input, Radio } from 'antd';
import { SelectProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import CompanyContactInfoModal from '@/components/general/CompanyContactInfoModal';

interface ReceptionDetailFormProps {
  formProps: FormProps;
  companySelectProps: SelectProps;
  shippersSelectProps: SelectProps;
}

const ReceptionDetailForm = (props: ReceptionDetailFormProps) => {
  const { t } = useTranslation();
  const { formProps, companySelectProps, shippersSelectProps } = props;
  const { form } = formProps;
  const company = Form.useWatch('company', form);

  return (
    <>
      <div className="ReceptionFormRow">
        <Form.Item label={t('Empresa o Técnico que envía el paquete')} required>
          <Flex align="center" gap={4}>
            <Form.Item
              name={'company'}
              rules={[
                {
                  required: true,
                  message: t('La {{field}} es requerida', { field: t('Empresa') }),
                },
              ]}
              noStyle>
              {/* <CompanySelector
                showFullName
                {...companySelectProps}
                loading={companySelectProps.loading}
                allowClear
                showSearch
              /> */}
              <AntdSelect
                {...companySelectProps}
                loading={companySelectProps.loading}
                allowClear
                showSearch
              />
            </Form.Item>
            {company && (
              <CompanyContactInfoModal
                company={company}
                openButton={<Button icon={<InfoCircleOutlined />} />}
              />
            )}
          </Flex>
        </Form.Item>
      </div>

      <div className="ReceptionFormRow">
        <Form.Item
          label={t('Operador logístico')}
          name={'shipper'}
          rules={[
            {
              required: true,
              message: t('El operador logístico es requerido'),
            },
          ]}>
          <AntdSelect {...shippersSelectProps} allowClear showSearch />
        </Form.Item>
        <Form.Item label={t('Número de seguimiento')} name={'tracking_number'}>
          <Input />
        </Form.Item>
      </div>
      <Form.Item
        label={t('Retiro en deposito')}
        name={'has_to_be_picked_up'}
        layout="horizontal"
        rules={[{ required: true, message: t('Este campo es requerido') }]}>
        <Radio.Group>
          <Radio value={true}>{t('Sí')}</Radio>
          <Radio value={false}>{t('No')}</Radio>
        </Radio.Group>
      </Form.Item>
    </>
  );
};

export default ReceptionDetailForm;
